// **************************************************
// Limit addresses
// **************************************************

const addressLimit = () => {
  const form = document.querySelector('.payer-form');

  if (form) {
    const limit = parseInt(form.getAttribute('data-limit'));
    const addresses = form.querySelectorAll('.address-list__item');
    const addNewBtn = form.querySelector('.address-list__add-btn');

    if (limit && addresses.length >= limit) {
      addNewBtn.classList.add('d-none');
    }
  }
};

document.addEventListener('DOMContentLoaded', () => {
  addressLimit();
});
attachEvent('.save-new-address', 'click', () => {
  addressLimit();
});
